import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SvgComponent } from '@components/svg.component';

@Component({
  selector: 'app-button-cta',
  standalone: true,
  imports: [CommonModule, SvgComponent, TranslateModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <div class="w-full" (click)="active && onClick.emit()">
      <button
        [disabled]="!active"
        [ngClass]="{
          'bg-vert-1 hover:bg-vert-2': type === 'green' && active,
          'bg-rose-1 hover:bg-rose-2': type === 'red' && active,
          'bg-white hover:bg-gris-3': type === 'grey' && active,
          'bg-gris-3 cursor-not-allowed opacity-50': !active,
          'cursor-pointer': active,
        }"
        [class]="
          'w-full flex items-center gap-4 border rounded border-gris-3 transition-colors ' +
          this.classes
        "
      >
        @switch (iconType) {
          @case ('material') {
            <span
              [class]="'material-icons ' + iconClasses"
              [ngClass]="{
                'text-white': (type === 'green' || type === 'red') && active,
                'fg-noir-2': type === 'grey' && active,
                'fg-gris-1': !active,
                'animate-spin': iconRotating,
              }"
              >{{ svgName }}</span
            >
          }
          @case ('svg') {
            <app-svg
              [svgPath]="'/assets/svg/' + svgName + '.svg'"
              [ngClass]="{
                'text-white': (type === 'green' || type === 'red') && active,
                'fg-noir-2': type === 'grey' && active,
                'fg-gris-1': !active,
                'animate-spin': iconRotating,
              }"
            />
          }
          @case ('material_outlined') {
            <span
              [class]="'material-symbols-outlined ' + iconClasses"
              [ngClass]="{
                'text-white': (type === 'green' || type === 'red') && active,
                'fg-noir-2': type === 'grey' && active,
                'fg-gris-1': !active,
                'animate-spin': iconRotating,
              }"
              >{{ svgName }}</span
            >
          }
        }
        @if (label.length) {
          <span
            class="font-semibold"
            [ngClass]="{
              'text-white': (type === 'green' || type === 'red') && active,
              'fg-noir-2': type === 'grey' && active,
              'fg-gris-1': !active,
            }"
            >{{
              label
                | translate
                  : (Object.keys(translateParameters).length > 0
                      ? translateParameters
                      : undefined)
            }}</span
          >
        }
      </button>
    </div>
  `,
})
export class CtaButton {
  Object = Object;

  @Input({ required: true }) label!: string;
  @Input({ required: true }) svgName!: string;
  @Input() iconType: 'svg' | 'material' | 'material_outlined' = 'svg';
  @Input() active: boolean = true;
  @Input() type: 'grey' | 'green' | 'red' = 'grey';
  @Input() classes: string = 'px-4 py-2 text-xs';
  @Input() iconClasses: string = '!text-md';
  @Input() iconRotating: boolean = false; // ← AJOUT
  @Input() translateParameters: { [key: string]: string | number } = {};

  @Output() onClick = new EventEmitter<void>();

  constructor() {}
}
